import React         from 'react';
import _             from 'lodash';
import numeral       from 'numeral';
import Cart          from 'pu-react/components/ProductCartForm';


const getLineItem = (props) => {
  if (!props.quote || !props.quote.line_items) return null;
  const lineItem = props.quote.line_items[0];
  if (lineItem && lineItem.quantities && lineItem.lead_times && lineItem.pricing) {
    return lineItem;
  }
  return null;
};

const getRow = (props) => {
  const n = _.parseInt(props.parameters.row_selected);
  return _.isInteger(n) ? n : null;
};

const getColumn = (props) => {
  const n = _.parseInt(props.parameters.column_selected);
  return _.isInteger(n) ? n : null;
};

export default (props) => {
  let unitPrice;
  let totalPrice;
  let quantity;
  let leadTime;
  //
  const row = getRow(props);
  const col = getColumn(props);
  const lineItem = getLineItem(props);
  if (lineItem && row !== null && col !== null) {
    quantity = lineItem.quantities[0];
    leadTime = lineItem.lead_times[0];
    const pricing = lineItem.pricing;
    if (pricing[0] !== undefined && pricing[0][0] !== undefined) {
      unitPrice = parseFloat(pricing[row][col] / parseFloat(quantity));
      unitPrice = accounting.toFixed(unitPrice, 4);
      totalPrice = accounting.toFixed(unitPrice * parseFloat(quantity), 2);

      unitPrice = accounting.formatMoney(unitPrice, {precision: 4});
      totalPrice = accounting.formatMoney(pricing[row][col]);
    }
  }

  const onChangeQuantity = e => props.onChangeParameter('quantities', [e.target.value]);
  const parametersQuantity = props.parameters.quantities[0];
  const properties = [
    { label: 'Qty:', value: <input type="number" onChange={onChangeQuantity} value={parametersQuantity || ''} className="form-control product-qty" min="1" /> },
    { label: 'Lead Time:', value: (leadTime ? `${leadTime} days` : '3 days') },
  ];

  return (
    <div>
      <Cart
        quoteStep={props.quoteStep}
        properties={properties}
        unitPrice={unitPrice}
        totalPrice={totalPrice}
        parametersChanged={false}
        usePriceMatrix={false} />
    </div>
  );
};
